import { ActionTree, Module } from 'vuex';
import Customer from '@/models/Customer';
import { SettingsState } from '@/store/storeStateInterface';
import Project from '@/models/Project';
import Actuator from '@/models/Actuator';
import Revision from '@/models/Revision';

const store: SettingsState = {
    customer: undefined,
    project: undefined,
    actuator: undefined,
    revision: undefined
};

const actions: ActionTree<any, any> = {

};

const mutations = {
    saveCustomer: (state: SettingsState, payload: { customer: Customer }) => {
        state.customer = payload.customer;
    },
    clearCustomer: (state: SettingsState) => {
        state.customer = undefined;
    },
    saveProject: (state: SettingsState, payload: { project: Project }) => {
        state.project = Project.parseFromObject(payload.project);
    },
    clearProject: (state: SettingsState) => {
        state.project = undefined;
    },
    saveActuator: (state: SettingsState, payload: { actuator: Actuator }) => {
        state.actuator = payload.actuator;
    },
    saveRevision: (state: SettingsState, payload: { revision: Revision }) => {
        state.revision = payload.revision;
    },

    updateProjectActuator: (state: SettingsState, payload: { actuator: Actuator }) => {
        if (!state.project?.actuators) {
            return;
        }

        const index = state.project.actuators.findIndex(
            (a: Actuator) => a.id === payload.actuator.id
        );

        if (index !== -1) {
            Object.assign(state.project.actuators[index], payload.actuator);
        }
    }
};

const getters = {
    // customer: (state: SettingsState) => {
    //     if (!state.customer) {
    //         return undefined;
    //     }
    //     return Customer.parseFromObject(state.customer);
    // },
    // project: (state: SettingsState) => {
    //     if (!state.project) {
    //         return undefined;
    //     }
    //     return Project.parseFromObject(state.project);
    // },
    // actuator: (state: SettingsState) => {
    //     if (!state.actuator) {
    //         return undefined;
    //     }
    //     return Actuator.parseFromObject(state.actuator);
    // },
    // revision: (state: SettingsState) => {
    //     if (!state.revision) {
    //         return undefined;
    //     }
    //     return Revision.parseFromObject(state.revision);
    // }

    customer: (state: SettingsState) => state.customer,
    project: (state: SettingsState) => state.project,
    actuator: (state: SettingsState) => state.actuator,
    revision: (state: SettingsState) => state.revision
};

const settingsStore: Module<any, any> = {
    namespaced: true,
    state: store,
    actions,
    mutations,
    getters
};

export default settingsStore;
